import {Component, Input} from '@angular/core';
import {EutrDocument} from "../../../shared/contracts";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'rb-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss']
})
export class DataComponent {
  @Input() eutrDocument: EutrDocument;
  @Input() form: FormGroup;

  constructor() {
  }
}
